// _forms/_shared/hooks/useDataFetcher.js
import { useState, useEffect, useRef } from 'react';

export const useDataFetcher = (slug, baseUrl, selectedPackage) => {
  const [paquetes, setPaquetes] = useState([]);
  const [selectedPaquete, setSelectedPaquete] = useState('');
  const [title, setTitle] = useState('');
  const [amount, setAmount] = useState('');
  const [totalAmount, setTotalAmount] = useState('');
  const [amountPerPerson, setAmountPerPerson] = useState('');
  const [numberOfCompetitors, setNumberOfCompetitors] = useState(1);
  const [formConfig, setFormConfig] = useState({ fields: { fields: [] } });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const hasFetched = useRef(false);
  const lastSlug = useRef(null);
  const packageSet = useRef(false); // ← NUEVO: Para evitar sobrescritura

  useEffect(() => {
    if (lastSlug.current !== slug) {
      hasFetched.current = false;
      lastSlug.current = slug;
    }
    if (!slug || hasFetched.current) return;

    const fetchData = async () => {
      try {
        const configResponse = await fetch(`${baseUrl}/formConfigs/${slug}`);
        if (!configResponse.ok) throw new Error('No se pudo cargar el formulario');
        const configData = await configResponse.json();

        let adjustedConfig = configData;
        if (Array.isArray(configData.fields)) {
          adjustedConfig = {
            ...configData,
            fields: {
              fields: configData.fields,
            },
          };
        }

        setFormConfig(adjustedConfig);

        const paquetesResponse = await fetch(`${baseUrl}/forms/template/${slug}`);
        if (!paquetesResponse.ok) throw new Error('Error al obtener paquetes');
        const paquetesData = await paquetesResponse.json();
        const paquetesList = paquetesData.packages || [];
        setPaquetes(paquetesList);

        // ✅ NUEVO: Si hay selectedPackage y la lista de paquetes ya está cargada
        // NO sobrescribir selectedPaquete si ya fue establecido
        if (!packageSet.current && selectedPackage) {
          const paqueteEncontrado = paquetesList.find(p => {
            if (p.id === selectedPackage.id) return true;
            if (p.id_package === selectedPackage.id) return true;
            if (p.id === selectedPackage.id_package) return true;
            if (p.title === selectedPackage.title || p.name === selectedPackage.title) return true;
            return false;
          });

          if (paqueteEncontrado) {
            // 🟢 FIX: el paquete crudo del backend usa "id_package", no "id".
            // Guardar paqueteEncontrado.id (undefined) dejaba selectedPaquete
            // sin valor real, rompiendo el cálculo de monto y el registro
            // más adelante en useFormulario / AdminFormulario.
            setSelectedPaquete(paqueteEncontrado.id_package ?? paqueteEncontrado.id);
            packageSet.current = true;
          }
        }
      } catch (error) {
        console.error('[ERROR] Error en fetchData:', error);
        setError(error.message);
      } finally {
        setIsLoading(false);
        hasFetched.current = true;
      }
    };

    fetchData();
  }, [slug, baseUrl]);

  // ✅ EFECTO PARA selectedPackage - CORREGIDO
  useEffect(() => {
    if (selectedPackage && paquetes.length > 0) {
  
      // ✅ Buscar por id_package O por id
      const paqueteEncontrado = paquetes.find(p => {
        // Comparar por id_package (el que viene de la DB)
        if (p.id_package && p.id_package === selectedPackage.id_package) return true;
        if (p.id_package && p.id_package === selectedPackage.id) return true;
        // Comparar por id (fallback)
        if (p.id && p.id === selectedPackage.id) return true;
        if (p.id && p.id === selectedPackage.id_package) return true;
        // Comparar por título
        if (p.title === selectedPackage.title || p.name === selectedPackage.title) return true;
        return false;
      });
  
      if (paqueteEncontrado) {
        // 🟢 FIX: idéntico al bug del efecto de arriba — usar id_package,
        // que es el campo real que trae el paquete crudo del backend.
        setSelectedPaquete(paqueteEncontrado.id_package ?? paqueteEncontrado.id);
        packageSet.current = true;
        setAmount(paqueteEncontrado.amount || '');
        setTitle(paqueteEncontrado.title || paqueteEncontrado.name || ''); 
        
        const amountPerPerson = parseFloat(paqueteEncontrado.amount) || 0;
        const numberOfCompetitors = parseInt(paqueteEncontrado.number_of_competitors) || 1;
        const total = (amountPerPerson * numberOfCompetitors).toFixed(2);
        
        setAmountPerPerson(amountPerPerson);
        setNumberOfCompetitors(numberOfCompetitors);
        setTotalAmount(total);
      } else {
        console.warn('[DataFetcher] No se encontró el paquete:', selectedPackage);
      }
    }
  }, [selectedPackage, paquetes]);

  return {
    formConfig,
    setFormConfig,
    paquetes,
    selectedPaquete,
    title,
    setTitle,
    amount,
    totalAmount,
    amountPerPerson,
    numberOfCompetitors,
    error,
    isLoading,
    setSelectedPaquete,
    setAmount,
  };
};